import {useEffect, useState} from "react"
import {useNavigate, useParams} from "react-router-dom"
import {useTranslation} from "react-i18next"

import {PaymentOption} from "./PaymentOption"

import {useAnalytics} from "@indebted/analytics"
import {paymentAPI} from "@indebted/api/paymentAPI"

function PaymentInFullOptionLink({
	RequiresAffordabilityAssessment,
	ShowDisclaimer,
}: {
	RequiresAffordabilityAssessment: boolean
	ShowDisclaimer: boolean
}) {
	const {secureCode} = useParams()
	const {track} = useAnalytics()
	const navigate = useNavigate()
	const [defaultPaymentMethod, setDefaultPaymentMethod] = useState(null)
	const {t} = useTranslation()

	useEffect(() => {
		paymentAPI.getDefaultPaymentMethod({secureCode: secureCode!}).then((result) => {
			setDefaultPaymentMethod(result.DefaultPaymentMethod)
		})
	}, [secureCode])

	const redirect = (RequiresAffordabilityAssessment: boolean) => {
		if (RequiresAffordabilityAssessment) {
			navigate(`/${secureCode}/affordability-assessment/payment-in-full/initiate`)
		} else {
			const url = defaultPaymentMethod
				? `/${secureCode}/payment-in-full/${defaultPaymentMethod}`
				: `/${secureCode}/payment-in-full/`
			navigate(url)
		}
	}

	return (
		<PaymentOption
			Type="PaymentInFull"
			onClick={() => {
				track("PIFButtonClicked", {SecureCode: secureCode})
				redirect(RequiresAffordabilityAssessment)
			}}
			Title={t("customer_get.outstanding_balance.payment.make_payment_in_full")}
			Description={t("customer_get.outstanding_balance.payment.clear_amount_today")}
			Disclaimer={ShowDisclaimer ? t("customer_get.outstanding_balance.settlement_offer.disclaimer") : undefined}
		/>
	)
}

export {PaymentInFullOptionLink}
